// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import axios from 'axios'
import './assets/css/style.css'
import BaiduMap from 'vue-baidu-map'
import "babel-polyfill"

import vTopo from 'vue-topo'
import 'vue-topo/dist/vue-topo.min.css'



Vue.use(ElementUI)
Vue.use(vTopo)
Vue.use(BaiduMap, {
  ak: '' //这个地方是官方提供的ak密钥
})
Vue.config.productionTip = false
Vue.prototype.axios = axios;

Vue.prototype.$http = 'http://www.hbguochao.com/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js